import React, { useState, useEffect } from 'react';
import { func, bool } from 'prop-types';

import { Box, Center, Text, Image } from '@chakra-ui/react';
import WithAnimation from '@/components/Common/WithAnimation';

import ImgPatra from '@/components/Section/Footer/assets/patra.png';
import playMusic from '@/components/Common/FloatingMusic/utils/playMusic';
import ScrollToDown from '@/components/Common/ScrollToDown/V1';

import { BG_COVER, IMG_LOGO_US, IMG_LOGO_WIF } from '@/constants/assets';
import { BUTTON_GRADIENT, BUTTON_PROPS } from '@/constants/colors';

/**
 * Function to render Component CoverV3
 * This component will be dissapear after user click show `Undangan`
 * @return {JSX.Element}
 */
function Cover({ loaded, onSeeDetail }) {
  const [loading, setLoading] = useState(false);
  const [showTitle, setShowTitle] = useState(false);

  const handleClickDetail = () => {
    if (loading) return undefined;

    playMusic();

    setLoading(true);
    setTimeout(() => {
      onSeeDetail();
      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    setShowTitle(true);
  }, []);

  return (
    <Box minHeight="100vh" bgColor="bgPrimary" bgImage={`url(${BG_COVER})`} bgSize="cover" paddingTop="16px">
      <Box width="100%" maxW="500px" position="absolute">
        <Image position="absolute" left="32px" src={IMG_LOGO_WIF} alt="" height="60px" />
        <Image position="absolute" marginTop="-8px" right="32px" src={ImgPatra} alt="" height="80px" />
      </Box>
      <Center width="100%" zIndex="2" height="calc(100vh - 64px)">
        <Box width="85%" position="relative" height="100%">
          {showTitle && (
            <Box
              color="secondaryColorText"
              letterSpacing="1px"
              fontWeight="400"
              fontSize="10px"
              width="100%"
              maxW="500px"
              padding="24px"
              bgSize="cover"
              borderRadius="16px"
              position="absolute"
              bottom="10%"
            >
              <Box textAlign="center" color="mainColorText">
                <WithAnimation>
                  <Image src={IMG_LOGO_US} alt="" maxW="100%" />
                  <Box fontSize="md" margin="16px 0">
                    <Text fontWeight="600">1 - 3 AGUSTUS 2022</Text>
                    <Text lineHeight="2" margin="16px 0" fontSize="sm">WORKSHOP | TALKSHOW <br /> DEMO | COACHING CLINIC <br /> FASHION SHOW | LIVE MUSIC</Text>
                  </Box>
                </WithAnimation>
              </Box>
              <WithAnimation>
                <ScrollToDown
                  loaded={loaded}
                  loading={loading}
                  marginTop="8px"
                  text="More Info"
                  color="white"
                  textTransform="uppercase"
                  boxShadow="lg"
                  fontFamily="body"
                  letterSpacing="2px"
                  size="sm"
                  className=""
                  borderRadius="32px"
                  paddingLeft="16px"
                  paddingRight="16px"
                  background={BUTTON_GRADIENT}
                  {...BUTTON_PROPS}
                  onClick={handleClickDetail}
                />
              </WithAnimation>
            </Box>
          )}
        </Box>
      </Center>
    </Box>
  );
}

Cover.propTypes = {
  loaded: bool.isRequired,
  onSeeDetail: func.isRequired,
};

export default Cover;
